const formatWebsiteUrl = url => {
  if (!url) {
    url = '';
  } else if (!url.includes('https://') && !url.includes('http://')) {
    url = `https://${url}`;
  }

  return url;
};

export const LeadDetails = ({
  topBar,
  contactExpanded,
  openEditContactModal,
  lead,
  isButtonEditContactDisabled,
  handleContactExpanded,
}) => {
  return (
    <>
      <div
        className={`rounded-2xl bg-white/50 p-3 ${
          contactExpanded ? 'hidden' : 'block'
        }`}
      >
        <div className="flex flex-wrap justify-between">
          <h6 className="text-lg font-medium">Campaign Details</h6>
          <div className="flex text-base 2xl:text-lg font-medium">
            Lead ID: &nbsp;
            <span className="text-accent-2"> {topBar.leadId ?? '_'} </span>
          </div>
        </div>
        <div className="flex flex-col gap-3 mt-3">
          <div className="text-base 2xl:text-lg font-medium">
            Campaign: &nbsp;
            <span className="text-accent-2"> {topBar.campaign ?? '_'} </span>
          </div>
          <div className="text-base 2xl:text-lg font-medium">
            Call Category: &nbsp;
            <span className="text-accent-2">
              {topBar.callCategory === 'OB_InitialReach'
                ? 'Initial Reach'
                : topBar.callCategory === 'OB_Callback'
                  ? 'Callback'
                  : (topBar.callCategory ?? '_')}
            </span>
          </div>
          <div className="text-base 2xl:text-lg font-medium">
            Last Dialed: &nbsp;
            <span className="text-accent-2"> {topBar.callDate || '_'} </span>
          </div>
        </div>
      </div>
      <div className="rounded-2xl bg-white/50 p-3">
        <div className={`flex flex-wrap justify-between items-center `}>
          <h6 className="flex text-lg font-medium">Contact Details</h6>
          <div className={`flex`}>
            <button
              onClick={openEditContactModal}
              data-hs-overlay="#edit-contact-modal"
              type="button"
              className="flex h-8 w-8 items-center justify-center rounded-lg border border-transparent bg-transparent text-accent-2 transition hover:bg-accent-2/10 focus:outline-none focus:ring focus:ring-accent-2/20 disabled:pointer-events-none disabled:opacity-50"
              disabled={isButtonEditContactDisabled}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                fill="currentColor"
                className="h-4 w-4"
              >
                <path d="m14.4 7.62-4-4 2.16-2.16 4 4Zm-8.94 8.94h-4v-4l7.9-7.94 4 4ZM17.58 4.44l-4-4a1.6 1.6 0 0 0-.47-.31 1.5 1.5 0 0 0-.57-.13 1.46 1.46 0 0 0-.54.11 1.38 1.38 0 0 0-.47.31L.42 11.52a1.38 1.38 0 0 0-.31.48 1.46 1.46 0 0 0-.11.55v4A1.43 1.43 0 0 0 1.44 18h4a1.46 1.46 0 0 0 .56-.11 1.38 1.38 0 0 0 .47-.31l11.1-11.1a1.38 1.38 0 0 0 .32-.48 1.46 1.46 0 0 0 .11-.54 1.5 1.5 0 0 0-.11-.55 1.6 1.6 0 0 0-.31-.47Z" />
              </svg>
            </button>
          </div>
        </div>
        <p className="text-lg font-bold text-accent-2 mt-2">{lead.contact}</p>
        <p className="text-lg font-medium mt-2">
          {lead.title ? lead.title + ' at ' + lead.company : ''}
        </p>
        <div
          className={`mt-2 space-y-0 2xl:space-y-4 transform transition-all duration-500 ${
            contactExpanded ? 'block' : 'hidden'
          }`}
        >
          <div className="relative">
            <input
              type="text"
              id="industry"
              name="industry"
              className="peer block w-full bg-transparent px-0 py-4 text-lg font-medium transition placeholder:text-transparent autofill:pb-2 autofill:pt-6 focus:border-x-transparent focus:border-b-secondary focus:border-t-transparent focus:pb-2 focus:pt-6 focus:outline-none focus:ring-0 disabled:pointer-events-none disabled:opacity-50 [&:not(:placeholder-shown)]:pb-2 [&:not(:placeholder-shown)]:pt-6"
              placeholder="Industry"
              value={lead.industry}
              readOnly
            />
            <label
              htmlFor="industry"
              className="pointer-events-none absolute start-0 top-0 flex h-full origin-top-left items-center truncate border border-transparent px-0 font-medium transition duration-100 ease-in-out peer-focus:-translate-y-3 peer-focus:scale-90 peer-focus:text-gray-500 peer-disabled:pointer-events-none peer-disabled:opacity-50 peer-[:not(:placeholder-shown)]:-translate-y-3 peer-[:not(:placeholder-shown)]:scale-90 peer-[:not(:placeholder-shown)]:text-gray-500"
            >
              Industry
            </label>
          </div>
          <div className="relative">
            <input
              type="text"
              id="address"
              name="address"
              className="peer block w-full bg-transparent px-0 py-4 text-lg font-medium transition placeholder:text-transparent autofill:pb-2 autofill:pt-6 focus:border-x-transparent focus:border-b-secondary focus:border-t-transparent focus:pb-2 focus:pt-6 focus:outline-none focus:ring-0 disabled:pointer-events-none disabled:opacity-50 [&:not(:placeholder-shown)]:pb-2 [&:not(:placeholder-shown)]:pt-6"
              placeholder="Contact Address"
              value={lead.address ?? '_'}
              readOnly
            />
            <label
              htmlFor="address"
              className="pointer-events-none absolute start-0 top-0 flex h-full origin-top-left items-center truncate border border-transparent px-0 font-medium transition duration-100 ease-in-out peer-focus:-translate-y-3 peer-focus:scale-90 peer-focus:text-gray-500 peer-disabled:pointer-events-none peer-disabled:opacity-50 peer-[:not(:placeholder-shown)]:-translate-y-3 peer-[:not(:placeholder-shown)]:scale-90 peer-[:not(:placeholder-shown)]:text-gray-500"
            >
              Contact Address
            </label>
          </div>
          <div className="grid grid-cols-3 gap-4 md:grid-cols-3 xl:grid-cols-3">
            <div className="relative">
              <input
                type="text"
                id="city"
                name="city"
                className="peer block w-full bg-transparent px-0 py-4 text-lg font-medium transition placeholder:text-transparent autofill:pb-2 autofill:pt-6 focus:border-x-transparent focus:border-b-secondary focus:border-t-transparent focus:pb-2 focus:pt-6 focus:outline-none focus:ring-0 disabled:pointer-events-none disabled:opacity-50 [&:not(:placeholder-shown)]:pb-2 [&:not(:placeholder-shown)]:pt-6"
                placeholder="City"
                value={lead.city ?? '_'}
                readOnly
              />
              <label
                htmlFor="city"
                className="pointer-events-none absolute start-0 top-0 flex h-full origin-top-left items-center truncate border border-transparent px-0 font-medium transition duration-100 ease-in-out peer-focus:-translate-y-3 peer-focus:scale-90 peer-focus:text-gray-500 peer-disabled:pointer-events-none peer-disabled:opacity-50 peer-[:not(:placeholder-shown)]:-translate-y-3 peer-[:not(:placeholder-shown)]:scale-90 peer-[:not(:placeholder-shown)]:text-gray-500"
              >
                City
              </label>
            </div>
            <div className="relative">
              <input
                type="text"
                id="state"
                name="state"
                className="peer block w-full bg-transparent px-0 py-4 text-lg font-medium transition placeholder:text-transparent autofill:pb-2 autofill:pt-6 focus:border-x-transparent focus:border-b-secondary focus:border-t-transparent focus:pb-2 focus:pt-6 focus:outline-none focus:ring-0 disabled:pointer-events-none disabled:opacity-50 [&:not(:placeholder-shown)]:pb-2 [&:not(:placeholder-shown)]:pt-6"
                placeholder="State"
                value={lead.state ?? '_'}
                readOnly
              />
              <label
                htmlFor="state"
                className="pointer-events-none absolute start-0 top-0 flex h-full origin-top-left items-center truncate border border-transparent px-0 font-medium transition duration-100 ease-in-out peer-focus:-translate-y-3 peer-focus:scale-90 peer-focus:text-gray-500 peer-disabled:pointer-events-none peer-disabled:opacity-50 peer-[:not(:placeholder-shown)]:-translate-y-3 peer-[:not(:placeholder-shown)]:scale-90 peer-[:not(:placeholder-shown)]:text-gray-500"
              >
                State
              </label>
            </div>
            <div className="relative">
              <input
                type="text"
                id="zipcode"
                name="zip"
                className="peer block w-full bg-transparent px-0 py-4 text-lg font-medium transition placeholder:text-transparent autofill:pb-2 autofill:pt-6 focus:border-x-transparent focus:border-b-secondary focus:border-t-transparent focus:pb-2 focus:pt-6 focus:outline-none focus:ring-0 disabled:pointer-events-none disabled:opacity-50 [&:not(:placeholder-shown)]:pb-2 [&:not(:placeholder-shown)]:pt-6"
                placeholder="Zip Code"
                value={lead.zip ?? '_'}
                readOnly
              />
              <label
                htmlFor="zipcode"
                className="pointer-events-none absolute start-0 top-0 flex h-full origin-top-left items-center truncate border border-transparent px-0 font-medium transition duration-100 ease-in-out peer-focus:-translate-y-3 peer-focus:scale-90 peer-focus:text-gray-500 peer-disabled:pointer-events-none peer-disabled:opacity-50 peer-[:not(:placeholder-shown)]:-translate-y-3 peer-[:not(:placeholder-shown)]:scale-90 peer-[:not(:placeholder-shown)]:text-gray-500"
              >
                Zip Code
              </label>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between mt-5">
          <div className="flex items-center">
            <a
              href={`mailto:${lead.email}`}
              name={'email'}
              className={`flex h-8 w-8 items-center justify-center rounded-lg border border-transparent bg-transparent text-blue-600 transition hover:bg-accent-2/10 focus:outline-none focus:ring focus:ring-accent-2/20 ${
                lead.email ? '' : 'pointer-events-none opacity-50'
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="h-5 w-5"
              >
                <path d="M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z" />
                <path d="m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" />
              </svg>
            </a>
            <a
              href={`${lead.linkedin}`}
              target="_blank"
              name={'linkedin'}
              className={`flex h-8 w-8 items-center justify-center rounded-lg border border-transparent bg-transparent text-blue-600 transition hover:bg-accent-2/10 focus:outline-none focus:ring focus:ring-accent-2/20 ${
                lead.linkedin ? '' : 'pointer-events-none opacity-50'
              }`}
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                fill="currentColor"
                className="h-6 w-6"
              >
                <path d="M7.5 5A2.518 2.518 0 0 0 5 7.5v17C5 25.867 6.133 27 7.5 27h17c1.367 0 2.5-1.133 2.5-2.5v-17C27 6.133 25.867 5 24.5 5Zm0 2h17c.285 0 .5.215.5.5v17a.49.49 0 0 1-.5.5h-17a.489.489 0 0 1-.5-.5v-17c0-.285.215-.5.5-.5Zm2.938 1.719a1.719 1.719 0 1 0 0 3.437 1.719 1.719 0 0 0 0-3.437Zm9.03 4.562c-1.433 0-2.386.785-2.78 1.531h-.063V13.5h-2.813V23h2.938v-4.688c0-1.238.246-2.437 1.781-2.437 1.512 0 1.532 1.398 1.532 2.5V23H23v-5.219c0-2.554-.543-4.5-3.531-4.5ZM9 13.5V23h2.969v-9.5Z" />
              </svg>
            </a>
            <a
              href={`${formatWebsiteUrl(lead.website)}`}
              target="_blank"
              name={'website'}
              className={`flex h-8 w-8 items-center justify-center rounded-lg border border-transparent bg-transparent text-blue-600 transition hover:bg-accent-2/10 focus:outline-none focus:ring focus:ring-accent-2/20 ${
                lead.website ? '' : 'pointer-events-none opacity-50'
              }`}
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="h-5 w-5"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20M2 12h20" />
              </svg>
            </a>
          </div>
          <span
            className="flex font-medium cursor-pointer border border-transparent bg-transparent text-accent-2 transition hover:bg-accent-2/10 focus:outline-none focus:ring focus:ring-accent-2/20 disabled:pointer-events-none disabled:opacity-50"
            onClick={() => {
              handleContactExpanded(prev => !prev);
            }}
          >
            {contactExpanded ? 'Show less' : 'See more'}
          </span>
        </div>
      </div>
    </>
  );
};
